import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  lprocessing:false,
  error: false,
};

export default function RateCardReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_CATEGORY_SUCCESS_ACTION:
      return {
        ...state,
        categoryList: action.payload.rows,
        countCatgry: action.payload.count,
      };
    case actionTypes.FETCH_SUB_CATEGORY_SUCCESS_ACTION:
      return {
        ...state,
        subcategoryList: action.payload.rows,
        countSubCatgryList: action.payload.count,
      };
    case actionTypes.FETCH_RATECARD_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        ratecardList: action.payload.rows,
        ratecardCount: action.payload.count,
      };
    case actionTypes.FETCH_RATECARD_INIT_ACTION:
      return {
        ...state,
        processing: true,
      };
    case actionTypes.FETCH_LOAD_METRIC_MAP_INIT_ACTION:
      return {
        ...state,
        lprocessing: true,
      };
    case actionTypes.FETCH_LOAD_METRIC_MAP_SUCCESS_ACTION:
      return {
        ...state,
        lprocessing: false,
        loadmetricmapList: action.payload.rows,
        loadmetricmapCount: action.payload.count,
      };

    case actionTypes.FETCH_LOAD_METRIC_MAP_FAIL_ACTION:
      return {
        ...state,
        lprocessing: false,
      };

    default:
      return {
        ...state,
      };
  }
}
